/**
 * Gets sentences from Chinese text using Chinese punctuation marks.
 *
 * @param {string} text The text to get sentences from.
 *
 * @returns {string[]} An array of sentences.
 */
export default function getSentences(text) {
  if (!text) {
    return [];
  }

  // Chinese sentence-ending punctuation marks
  const chineseSentenceEnders = /[。！？；]/;
  const englishSentenceEnders = /[.!?;]/;

  // Split by Chinese and English sentence enders, keeping the punctuation
  const sentences = text.split(/([。！？；.!?;])/).filter(sentence => sentence.trim() !== '');

  const result = [];
  let currentSentence = '';

  for (let i = 0; i < sentences.length; i++) {
    const part = sentences[i];

    if (chineseSentenceEnders.test(part) || englishSentenceEnders.test(part)) {
      // This is punctuation - add to current sentence and finalize it
      currentSentence += part;
      if (currentSentence.trim()) {
        result.push(currentSentence.trim());
      }
      currentSentence = '';
    } else {
      // This is sentence content
      currentSentence += part;
    }
  }

  // Add any remaining sentence
  if (currentSentence.trim()) {
    result.push(currentSentence.trim());
  }

  return result.filter(sentence => sentence.length > 0);
}
